import { IconTypes } from './Icons'

export default function OpenEye({
  color = 'white',
  fontSize = '1.6rem',
  rotate = 0,
  className = '',
}: Readonly<IconTypes>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 16 16'
      style={{
        width: '1em',
        height: '1em',
        fontSize,
        transform: `rotate(${rotate}deg)`,
      }}
      className={className}
      width='12'
      height='12'
      fill={color}
    >
      <path
        d='M6.18747 8C6.18747 8.46413 6.37184 8.90925 6.70003 9.23744C7.02822 9.56563 7.47334 9.75 7.93747 9.75C8.4016 9.75 8.84672 9.56563 9.1749 9.23744C9.50309 8.90925 9.68747 8.46413 9.68747 8C9.68747 7.53587 9.50309 7.09075 9.1749 6.76256C8.84672 6.43437 8.4016 6.25 7.93747 6.25C7.47334 6.25 7.02822 6.43437 6.70003 6.76256C6.37184 7.09075 6.18747 7.53587 6.18747 8ZM14.7218 7.59687C13.2406 4.47656 11.0015 2.90625 7.99997 2.90625C4.99684 2.90625 2.75934 4.47656 1.27809 7.59844C1.21868 7.72424 1.18787 7.86165 1.18787 8.00078C1.18787 8.13991 1.21868 8.27732 1.27809 8.40312C2.75934 11.5234 4.99841 13.0937 7.99997 13.0937C11.0031 13.0937 13.2406 11.5234 14.7218 8.40156C14.8422 8.14844 14.8422 7.85469 14.7218 7.59687ZM7.93747 10.75C6.41872 10.75 5.18747 9.51875 5.18747 8C5.18747 6.48125 6.41872 5.25 7.93747 5.25C9.45622 5.25 10.6875 6.48125 10.6875 8C10.6875 9.51875 9.45622 10.75 7.93747 10.75Z'
        fill={color}
      />
    </svg>
  )
}
